import Vue from 'vue';
import Router from 'vue-router';
import * as Roots from './views';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'home',
      },
    },
    {
      path: '/accueil',
      name: 'home',
      component: Roots.Home,
      meta: { contentId: 'b58f8997-47c3-416b-87e2-8e5db8a89e51' },
    },
    {
      path: '/notre-organisation',
      name: 'office',
      component: Roots.Office,
      meta: { contentId: '60c96db1-daa9-4f21-9b50-f0d2b5cefbd8' },
    },
    {
      path: '/nos-metiers',
      name: 'trades',
      component: Roots.Trades,
      meta: { contentId: '4af20ef0-1ae3-48b9-aad8-98b3e0e36a26' },
    },
    {
      path: '/nos-services/transport',
      name: 'services-transport',
      component: Roots.Services,
      meta: { contentId: 'e235cad0-7bb0-40ad-aada-aa3bb52c5dad' },
    },
    {
      path: '/nos-services/entreprises',
      name: 'services-companies',
      component: Roots.Services,
      meta: { contentId: '141b2190-0dfa-41f1-a566-d9248cde6d47' },
    },
    {
      path: '/nos-services/franchises',
      name: 'services-franchised',
      component: Roots.Services,
      meta: { contentId: 'a4ef29ca-cc50-4b85-8353-6bd79fc8995b' },
    },
    {
      path: '/nos-services/construction',
      name: 'services-building',
      component: Roots.Services,
      meta: { contentId: '5c03c832-f34f-47d3-8f32-1ae446674fd1' },
    },
    {
      path: '/nos-services/assurances-personnes',
      name: 'services-people',
      component: Roots.Services,
      meta: { contentId: 'c59620c1-24f4-4a82-89b6-92d4f60ee6ca' },
    },
    {
      path: '/nos-services/assurances-particuliers',
      name: 'services-individuals',
      component: Roots.Services,
      meta: { contentId: '624f401e-5c99-4c48-ab32-92dc640fe5fc' },
    },
    {
      path: '/actualites',
      name: 'news',
      component: Roots.News,
      meta: { contentId: 'b58f8997-47c3-416b-87e2-8e5db8a89e51' },
    },
    {
      path: '/actualites/:slug',
      name: 'article',
      component: Roots.Article,
      meta: { contentId: 'b58f8997-47c3-416b-87e2-8e5db8a89e51' },
    },
    {
      path: '/nous-rejoindre',
      name: 'join',
      component: Roots.Join,
      meta: { contentId: 'ffd94206-bc9a-478d-ace2-cf4c32b80f92' },
    },
    {
      path: '/contact/(mail-envoye)?',
      name: 'contact',
      component: Roots.Contact,
      meta: { contentId: 'b58f8997-47c3-416b-87e2-8e5db8a89e51' },
    },
    {
      path: '/mentions-legales',
      name: 'legal-notices',
      component: Roots.LegalNotices,
      meta: { contentId: 'b58f8997-47c3-416b-87e2-8e5db8a89e51' },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
